const PRODUCTION_HOSTNAME = "klimaportal.eu";

export function getWebSocketUrl(): string {
  if (import.meta.env.VITE_WEBSOCKET_URL) {
    return import.meta.env.VITE_WEBSOCKET_URL.replace(/\/$/, "");
  }
  if (window.location.hostname.includes(PRODUCTION_HOSTNAME)) {
    return window.location.origin;
  }
  const apiEndpoint = import.meta.env.VITE_API_ENDPOINT;
  if (!apiEndpoint) {
    return "";
  }
  return apiEndpoint.replace(/\/graphql.*$/, "").replace(/\/$/, "");
}
